module.exports = {
	"articleTitle1": "Photos of the Week: April 1-7, 2016 ",
	"catImage": "orangestar.png",
	"totalCats": 3,
	"name": "Palmer Field",
	"articleLink2": "https://www.michigandaily.com/section/multimedia/photos-week-november-20-26-2015",
	"articleSnippet1": "Apr 5, 2016 ... Photos of the Week: April 1-7, 2016. Students celebrate Holi, a Hindu festival that \ncelebrates the beginning of spring, at Palmer field Sunday.",
	"articleSnippet2": "Nov 22, 2015 ... LSA sophomore Audrey Kim places a carrot in her snowman during the first \nsnowfall of the season at Palmer Field this Saturday. Grant Hardy/ ...",
	"totalMisc": 1,
	"articleTitle2": "Photos of the Week: November 20-26, 2015 ",
	"address": "No Address",
	"images": [
		{
			"source": "https://www.michigandaily.com/sites/default/files/styles/large/public/160405/eaa.NEW_.Holi_.4.3.16.0061.jpg?itok=bl_OqNQJ",
			"author": "Evan Aaron",
			"caption": "Students celebrate Holi, a Hindu festival that celebrates the beginning of spring, at Palmer field Sunday."
		}
	],
	"position": {
		"lat": 42.280622,
		"lng": -83.73274
	},
	"tips": [
		{
			"text": "The sloped grass in front of Mojo is perfect for sunbathing!! There's also comfortable chairs if you don't want to sit on the grass.",
			"person": "Amelia Cacchione"
		}
	],
	"articleLink1": "https://www.michigandaily.com/section/multimedia/photos-week-april-1-7",
	"categories": {
		"yogaspot": 1,
		"sunbathingspot": 1,
		"recarea": 1,
		"studyspot": 1,
		"pickupsports": 1,
		"location": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/palmerfield.json
// module id = 943
// module chunks = 0